import { gql } from '@apollo/client'

export const MARK_CASE_NOTIFICATIONS_READ_MUTATION = gql`
  mutation markCaseNotificationsRead($caseId: ID!) {
    markCaseNotificationsRead(caseId: $caseId) {
      success
      errors
    }
  }
`
